import React, { useState } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";

import Navbar from './components/Navbar'
// import Dashboard from './scenes/dashboard';
// import Businesses from './scenes/businesses';
import Links from './scenes/links';
import Form from './scenes/links/form';
import Apps from './scenes/apps';
import Admins from './scenes/admins';
import ApiKeys from './scenes/apikeys'
import AppForm from './scenes/apps/AppForm'
import FeaturedBusinessForm from './scenes/featuredbusinesses/form';
import FeaturedBusinesses from './scenes/featuredbusinesses';
import TokenForm from './scenes/tokens/form'

import Tokens from './scenes/tokens';
import Login from './scenes/login';
import * as Account from './account';
import Ads from './scenes/ads';
import AdForm from './scenes/ads/AdForm'
import Articles from './scenes/articles';
import ArticleForm from './scenes/articles/ArticleForm';

function App(props) {

  const [account, updateAccount] = useState(Account.getUserAccount());

  function authorized(googleAccount, idToken) {
    if (idToken !== null) {
      googleAccount.idToken = idToken;
    }
    sessionStorage.setItem(Account.accountSessionKey, JSON.stringify(googleAccount))
    updateAccount(googleAccount);
  }

  if (account === null || account === undefined) {
    return (<Login authorized={authorized}></Login>);
  }

  return (
    <Router>
      <Navbar authorized={authorized} account={account}></Navbar>
      <div className="main-content">
        <Routes>
          <Route path="/articles/:id" element={<ArticleForm />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/apikeys" element={<ApiKeys />} />
          <Route path="/admins" element={<Admins />} />
          <Route path="/ads/:id" element={<AdForm />} />
          <Route path="/ads" element={<Ads />} />
          <Route path="/apps/:id" element={<AppForm />} />
          <Route path="/apps" element={<Apps />} />
          <Route path="/links/:id" element={<Form />} />
          <Route path="/links" element={<Links />} />
          <Route path="/featured/:id" element={<FeaturedBusinessForm />} />
          <Route path="/featured" element={<FeaturedBusinesses />} />
          <Route path="/tokens/:id" element={<TokenForm />} />
          <Route path="/tokens" element={<Tokens />} />
          <Route exact path="/" element={<Links />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
